import React from 'react'

interface TooltipProps {
  title: string
  className?: string
  children: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  children,
}) => {
  return (
    <div className={`relative group ${className}`}>
      <span className="absolute bottom-[calc(100%+12px)] left-1/2 w-[160px] -translate-x-1/2 rounded-[4px] bg-[#C53030] p-[8px] text-center text-[14px] font-[500] text-[#fefefe] opacity-0 transition-opacity duration-[400ms] invisible group-hover:visible group-hover:opacity-100 before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-l-[6px] before:border-r-[6px] before:border-t-[6px] before:border-solid before:border-transparent before:border-t-[#C53030] before:content-['']">
        {title}
      </span>
      {children}
    </div>
  )
}

export default Tooltip
